import './styles.scss'
import Label from "components/Label";
// import { data } from './mockData'
import BenefitsItem from "./BenefitsItem";
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';

const Benefits = ({ data, isLoading }) => {
    const container = useRef();
    const { tag, title, description, cards } = data

    useAnimation({
        items: ['.benefits-head h2', '.benefits-head body1', '.benefits-item'],
        container,
        dependencies: [isLoading],
    })
    return (
        <section ref={container} className="inner-container benefits">
            <div className='benefits-head'>
                <Label text={tag} />
                <h2>{title}</h2>
                {
                    data.desc && <div className="body1">{description}</div>
                }
            </div>

            <div className="benefits-container">
                {
                    cards?.map((item, index) => (
                        <BenefitsItem key={index} data={item} />
                    ))
                }
            </div>
        </section>
    );
}

export default Benefits;